module.exports = __webpack_public_path__ + "static/media/0202.a6ce0b2b.png";